export const transformString = (input: string) => {
  // Use the toLowerCase() method to convert the string to lowercase
  const lowercaseString = input.toLowerCase();

  // Use the replace() method with a regular expression to replace spaces with hyphens
  const transformedString = lowercaseString.replace(/ /g, "-");

  return transformedString;
};
